import BaseGeocodeService from './baseGeocodeService'
import NomiNatimGeocodeService from './implementations/nominatim/nominatimGeocodeService'
//import GoogleGeocodeService from './implementations/google/googleGeocodeService'
import ClickGoGeocodeService from './implementations/clickgo/clickgoGeocodeService'
import GeocodeProvider from './geocodeProvider'

class GeocodeService extends BaseGeocodeService {
  constructor (provider) {
    super()
    this._geocodeService = null
    this.setProvider(provider)
  }

  async reverseGeocode (latitude, longitude) {
    return this._geocodeService.reverseGeocode(latitude, longitude)
  }

  setProvider (provider) {
    this.provider = provider
    switch (provider) {
      case GeocodeProvider.Nominatim:
        this._geocodeService = NomiNatimGeocodeService
        break
      // case GeocodeProvider.Google:
      //   this._geocodeService = GoogleGeocodeService
      //   break
      case GeocodeProvider.ClickGo:
        this._geocodeService = ClickGoGeocodeService
        break
      default:
        this.provider = GeocodeProvider.ClickGo
        this._geocodeService = ClickGoGeocodeService
        break
    }
  }

  getProvider () {
    return this.provider
  }
}

const geocodeService = new GeocodeService()
export default geocodeService



// WEBPACK FOOTER //
// ./src/services/geocoding/geocodeService.js